import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

import { apiHandle, baseURL } from "../config/apiHandle/apiHandle";
import { type_constant } from "../utils/asyncStatus";

export const getDashboardDataAsync = createAsyncThunk(
  type_constant.GET_DASHBOARD_DATA,
  async () => {
    try {
      const response = await apiHandle.get(`/admin-dashboard`);
      const res_data = await response.data;
      // console.log("res_data", res_data);
      return res_data;
    } catch (error) {
      console.log("error", error);
      if (error?.response?.data) {
        throw Error(error.response.data.message);
      } else {
        throw Error(error.message);
      }
    }
  }
);

export const getAnalyticsAsync = createAsyncThunk(
  type_constant.GET_ANALYTICS,
  async () => {
    try {
      const response = await apiHandle.get(`/admin/analytics`);
      const res_data = await response.data;
      return res_data?.data ?? res_data;
    } catch (error) {
      if (error?.response?.data) {
        throw Error(error.response.data.message);
      }
      throw Error(error.message);
    }
  }
);

// Broadcast a push notification to all / users / pros
export const broadcastNotificationAsync = createAsyncThunk(
  type_constant.BROADCAST_NOTIFICATION,
  async (payload) => {
    try {
      const response = await apiHandle.post(`/admin/broadcast-notification`, payload);
      const res_data = await response.data;
      return res_data;
    } catch (error) {
      if (error?.response?.data) {
        throw Error(error.response.data.message);
      }
      throw Error(error.message);
    }
  }
);

// History of past broadcasts
export const getNotificationsHistoryAsync = createAsyncThunk(
  type_constant.GET_NOTIFICATIONS_HISTORY,
  async () => {
    try {
      const response = await apiHandle.get(`/admin/notifications-history`);
      const res_data = await response.data;
      return res_data?.history ?? [];
    } catch (error) {
      if (error?.response?.data) {
        throw Error(error.response.data.message);
      }
      throw Error(error.message);
    }
  }
);

export const getSubscriptionsAsync = createAsyncThunk(
  type_constant.GET_SUBSCRIPTIONS,
  async () => {
    try {
      const response = await apiHandle.get(`/admin/subscriptions`);
      const res_data = await response.data;
      return res_data;
    } catch (error) {
      console.log("error", error);
      if (error?.response?.data) {
        throw Error(error.response.data.message);
      } else {
        throw Error(error.message);
      }
    }
  }
);

export const cancelSubscriptionAsync = createAsyncThunk(
  type_constant.CANCEL_SUBSCRIPTION,
  async (userId) => {
    try {
      const response = await apiHandle.post(`/admin/cancel-subscription/${userId}`);
      const res_data = await response.data;
      return res_data;
    } catch (error) {
      console.log("error", error);
      if (error?.response?.data) {
        throw Error(error.response.data.message);
      } else {
        throw Error(error.message);
      }
    }
  }
);

// Grant a membership manually (no Stripe charge). Payload: { user_id, plan_name?, expiry_date?, notes? }
export const addSubscriptionAsync = createAsyncThunk(
  type_constant.ADD_SUBSCRIPTION,
  async (payload) => {
    try {
      const response = await apiHandle.post(`/admin/add-subscription`, payload);
      const res_data = await response.data;
      return res_data;
    } catch (error) {
      console.log("error", error);
      if (error?.response?.data) {
        throw Error(error.response.data.message);
      } else {
        throw Error(error.message);
      }
    }
  }
);

// Create a REAL Stripe subscription (charges saved card $10 CAD now, then monthly).
// Payload: { user_id }
export const createRealSubscriptionAsync = createAsyncThunk(
  "admin/createRealSubscription",
  async (payload) => {
    try {
      const response = await apiHandle.post(`/admin/create-real-subscription`, payload);
      return response.data;
    } catch (error) {
      if (error?.response?.data) throw Error(error.response.data.message);
      throw Error(error.message);
    }
  }
);
